import React from 'react';
import { FilterDefinitions } from './types';
import { useFilteringForm } from './useForm';
import { FormProvider } from 'react-hook-form';

export type FilterCustomViewProps = {
  children: React.ReactNode;
};

export const FilterCustomView = <T extends FilterDefinitions>({
  children,
}: FilterCustomViewProps): React.ReactElement => {
  const methods = useFilteringForm<T>();

  return (
    <FormProvider {...methods}>
      <form>{children}</form>
    </FormProvider>
  );
};
FilterCustomView.DisplayName = 'FilterCustomView';
